import PageNormal from 'hw/page/normal';
// const PageImage = () => import('hw/page/image');
// const PageVideo = () => import('hw/page/video');
import PageSubject from 'hw/page/subject';

export default [
    {path: '/normal/:id', component: PageNormal},
    {path: '*', component: PageNormal},
    {path: '/image/:id', component: PageNormal},
    {path: '/video/:id', component: PageNormal},
    {path: '/subject/:id', component: PageSubject}
];



// WEBPACK FOOTER //
// ./src/hw/router/index.js